<template>
  <div>
    <div class="block border-2 rounded border-gray-100">
      <h2
        class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
        style="margin-bottom: 22px"
      >
        Properties
      </h2>

      <el-form
        class="pr-4"
        :model="properties"
        ref="form"
        label-width="240px"
      >
        <template v-for="key in keys">
          <el-form-item
            v-if="enabled(properties, key)"
            :label="label(key)"
            :rules="rules(key)"
            :prop="key"
            :key="key"
          >
            <el-input
              v-if="htmlField(key) === 'text'"
              v-model="properties[key]"
              v-on:change="persistStateToLocalStorage()"
            ></el-input>

            <el-select
              v-if="htmlField(key) === 'select'"
              v-model="properties[key]"
              placeholder="Please select one option"
              v-on:change="persistStateToLocalStorage()"
            >
              <el-option
                v-if="!required(key)"
                label="Please select one option"
                value
              />
              <el-option
                v-for="choice in choices(entities, key)"
                :key="choice.value"
                :label="choice.label"
                :value="choice.value"
              ></el-option>
            </el-select>

            <el-input-number
              v-if="htmlField(key) === 'number'"
              v-model="properties[key]"
              v-on:change="persistStateToLocalStorage()"
            ></el-input-number>

            <el-color-picker
              v-if="htmlField(key) === 'color'"
              v-model="properties[key]"
              v-on:change="persistStateToLocalStorage()"
            ></el-color-picker>

            <div
              class="leading-7 text-xs font-medium text-gray-500"
              v-if="help(key)"
            >
              {{ help(key) }}
            </div>
          </el-form-item>
        </template>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'app-property-form',

  mounted() {
    if (this.keys) {
      this.keys.forEach((key) => {
        const referenceKey = `tooltip${key}`;
        if (
          this.$refs[referenceKey] &&
          this.$refs[referenceKey].referenceElm
        ) {
          this.$refs[
            referenceKey
          ].referenceElm.setAttribute('tabindex', -1);
        }
      });
    }

    this.$store.commit(
      'builder/propertyCurrent/form',
      this.$refs.form,
    );
  },

  computed: {
    ...mapGetters({
      properties: 'builder/propertyCurrent/current',
      entities: 'builder/entityCurrent/list',
      keys: 'builder/property/keys',
      enabled: 'builder/property/enabled',
      required: 'builder/property/required',
      input: 'builder/property/input',
      label: 'builder/property/label',
      htmlField: 'builder/property/htmlField',
      help: 'builder/property/help',
      choices: 'builder/property/choices',
    }),

    rules() {
      return (key) => {
        if (!this.required(key)) {
          return null;
        }

        const rules = {
          required: true,
          message: `${this.label(key)} is required`,
          trigger: 'blur',
        };

        if (this.htmlField(key) === 'number') {
          rules.type = 'number';
        }

        return rules;
      };
    },
  },

  methods: {
    ...mapActions({
      persistStateToLocalStorage:
        'builder/persistStateToLocalStorage',
    }),
  },
};
</script>

<style></style>
